import {PlacedBin} from '../placed-bin';

export interface CornerDef {
    x: number;
    y: number;
    binIndex: number;
    placedBin: PlacedBin;
}

export const CORNER_DEF_GETTERS: Array<(placedBin: PlacedBin) => CornerDef> = [
    placedBin => ({
        x: placedBin.x,
        y: placedBin.y,
        binIndex: 2,
        placedBin
    }),
    placedBin => ({
        x: placedBin.nextX,
        y: placedBin.y,
        binIndex: 3,
        placedBin
    }),
    placedBin => ({
        x: placedBin.nextX,
        y: placedBin.nextY,
        binIndex: 0,
        placedBin
    }),
    placedBin => ({
        x: placedBin.x,
        y: placedBin.nextY,
        binIndex: 1,
        placedBin
    })
];
